<template>
  <div class="home">
    <div class="banner-container">
      <!-- <img src="../assets/images/home1.jpg" alt=""> -->
       <img src="https://minio.kemingvr.com/public/20260109141901037/d35e2414-ee6e-4fd9-ad50-0004e8403a86.jpg" alt="">
    </div>
    <div class="innovate-container">
      <div class="innovate-wrap" :style="{ backgroundImage: 'url(' + desc.iconUrl + ')' }">
        <div class="big-title">
          {{ desc.moduleTitle }}
        </div>
        <div class="small-desc">
          {{ desc.moduleDesc }}
        </div>
        <div class="btns">
          <div class="zixun" @click="consultFn">咨询解决方案</div>
          <div class="look" @click="lookSuccess">查看成功案例</div>
        </div>
      </div>
    </div>
    <div class="data-container">
      <div class="data-wrap">
        <div class="item" v-for="item in datas" :key="item.id">
          <span class="num" style="margin-bottom: 10px;">{{ item.moduleDesc }}</span>
          <span class="desc">{{ item.moduleTitle }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="about-container">
      <div class="about-wrap">
        <div class="left">
          <div class="title">关于广州科明数字</div>
          <div class="desc">
            广州科明数字技术有限公司自2016年成立以来，始终专注于数字技术的研发、推广、应用与平台化运营，是国内领先的VR、AR、AI及IoT综合解决方案提供商。公司以“VR+AI+IoT融合生态”为核心发展战略，构建以智能感知、虚拟仿真与数据智能为支撑的新一代数字创新体系，推动教育、产业与技术的深度融合。通过在智能物联网、人工智能算法创新、虚拟现实应用与教育数字化转型等领域的持续突破，科明数字致力于打造贯通“教、学、研、练、产”全链条的数字化新生态，助力产业升级与智慧教育高质量发展。
          </div>
          <div class="power">
            <div class="item" v-for="value in 4" :key="value">
              <div class="icons">
                <svg t="1762321603511" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4770" width="20" height="20">
                  <path
                    d="M768 332.8l-76.8 76.8c0 0 0-307.2-256-409.6 0 0-25.6 281.6-153.6 384s-384 409.6 128 640c0 0-256-281.6 76.8-486.4 0 0-25.6 102.4 102.4 204.8s0 281.6 0 281.6S1203.2 870.4 768 332.8z"
                    p-id="4771" fill="#275eff"></path>
                </svg>
              </div>
              <div class="content">
                <span class="name">人工智能</span>
                <span class="text">以AI驱动智慧教学与精准评测，提升教育智能化水平。</span>
              </div>
            </div>
          </div>
        </div>

        <div class="right">
          <img src="../assets/images/案例1.jpg" alt="">
        </div>
      </div>
    </div> -->
    <div class="product-container">
      <div class="title">
        <span>{{ service.moduleTitle }}</span>
      </div>
      <div class="sub-title">
        <span>{{ service.moduleDesc }}</span>
      </div>
      <div class="card-wrap">
        <swiper ref="mySwiper" :options="swiperOptions" style="width: 94%; margin: 0 auto;">
          <swiper-slide v-for="item in service.moduleChildListDto" :key="item.id">
            <div class="card-item">
              <div class="img">
                <img :src="item.iconUrl" alt="">
              </div>
              <div class="content">
                <div class="content-title">
                  <span>{{ item.moduleTitle }}</span>
                </div>
                <div class="content-desc">
                  {{ item.moduleDesc }}
                </div>
                <div class="content-tip">
                  <span>了解更多</span>
                </div>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

      </div>
      <div class="look-all">
        <span @click="lookAllProFn">查看全部产品</span>
      </div>
    </div>
    <div class="coop-container">
      <div class="title">
        <span>强悍的生态链</span>
      </div>
      <div class="sub-title">
        <span>我们的客户遍布各个行业，包括世界500强企业、大型国有企业和快速发展的创新公司</span>
      </div>
      <div class="logo-row-BtmM">
        <div class="logo-row-track-SYyh" style="animation-duration: 75s">
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/1.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/2.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/3.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/4.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/5.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/6.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/7.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/8.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/9.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/10.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/11.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/12.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/13.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/14.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/1.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/2.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/3.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/4.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/5.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/6.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/7.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/8.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/9.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/10.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/11.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/12.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/13.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/14.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
        </div>
      </div>
      <div class="logo-row-BtmM" style="padding-left: 85px; margin-top: -30px;">
        <div class="logo-row-track-SYyh" style="animation-duration: 75s">
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/15.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/16.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/17.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/18.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/19.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/20.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/21.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/22.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/23.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/24.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/25.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/26.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/27.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/28.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/15.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/16.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/17.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/18.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/19.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/20.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/21.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/22.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/23.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/24.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/25.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/26.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/27.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/28.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
        </div>
      </div>
      <div class="logo-row-BtmM" style="margin-top: -30px;">
        <div class="logo-row-track-SYyh" style="animation-duration: 75s">
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/29.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/30.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/31.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/32.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/33.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/34.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/35.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/36.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/37.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/38.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/39.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/40.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/41.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/42.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/29.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/30.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/31.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/32.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/33.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/34.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/35.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/36.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/37.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/38.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/39.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/40.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/41.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
          <div class="partner-logo-container-rGcQ">
            <div class="logo-wrap">
              <img src="../assets/logo/42.png" alt="" class="partner-logo-RBoq">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="success-container">

      <div class="success-wrap">
        <div class="title">
          <span>{{ cases.moduleTitle }}</span>
        </div>
        <div class="sub-title">
          <span class="sub">{{ cases.moduleDesc }}</span>
          <span class="all-sucess">查看全部案例</span>
        </div>
        <div class="card-wrap">
          <div class="card-item" v-for="item in caseItem.slice(0,3)" :key="item.id">
            <div class="item-img-wrap">
              <img :src="item.coverUrl" alt="">
              <div class="desc">
                <div class="tag">
                  <span>{{ item.moduleTitle }}</span>
                </div>
                <div class="title">
                  <span>{{ item.source }}</span>
                </div>
              </div>
            </div>
            <div class="txt">
              <span>{{ item.subTitle}}</span>
            </div>
            <div class="detail-wrap">
              <span @click="lookCase(item.id)">查看详情</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="evaluate-container">
      <div class="title">{{ evaluate.moduleTitle }}</div>
      <div class="text">{{ evaluate.moduleDesc }}</div>
      <div class="card-wrap">
        <div class="card-item" v-for="item in evaluate.moduleChildListDto" :key="item.id">
          <div class="icons">
            <svg t="1761812878005" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="15274" width="60" height="60">
              <path
                d="M470.9888 261.77536l0 98.54976c0 13.3632-10.83392 24.19712-24.19712 24.19712-47.68768 0-73.6256 48.90624-77.21984 145.43872l77.21984 0c13.3632 0 24.19712 10.84416 24.19712 24.19712l0 208.0768c0 13.3632-10.83392 24.19712-24.19712 24.19712L240.90624 786.432c-13.37344 0-24.19712-10.84416-24.19712-24.19712l0-208.0768c0-46.27456 4.6592-88.73984 13.84448-126.22848 9.4208-38.44096 23.87968-72.04864 42.96704-99.90144 19.64032-28.6208 44.20608-51.07712 73.02144-66.72384 29.00992-15.73888 62.74048-23.72608 100.25984-23.72608C460.15488 237.57824 470.9888 248.41216 470.9888 261.77536zM783.09376 384.52224c13.3632 0 24.19712-10.84416 24.19712-24.19712l0-98.54976c0-13.3632-10.83392-24.19712-24.19712-24.19712-37.50912 0-71.23968 7.9872-100.2496 23.72608-28.81536 15.64672-53.39136 38.10304-73.03168 66.72384-19.08736 27.8528-33.54624 61.46048-42.96704 99.91168-9.17504 37.49888-13.83424 79.96416-13.83424 126.21824l0 208.0768c0 13.3632 10.83392 24.19712 24.19712 24.19712l205.8752 0c13.3632 0 24.19712-10.84416 24.19712-24.19712l0-208.0768c0-13.3632-10.83392-24.19712-24.19712-24.19712L706.9696 529.96096C710.51264 433.42848 736.07168 384.52224 783.09376 384.52224z"
                p-id="15275" fill="#2D80FF"></path>
            </svg>
          </div>
          <div class="txt">
            {{ item.moduleExt }}
          </div>
          <div class="info">
            <div class="avatar">
              <img :src="item.iconUrl" alt="">
            </div>
            <div class="name-desc">
              <span class="name">{{ item.moduleTitle }}</span>
              <span class="desc">{{ item.moduleDesc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="consult-container">
      <div class="title">准备好开始您的数字化转型之旅了吗？</div>
      <div class="text">联系我们，获取专属的数字化转型解决方案咨询，开启业务增长新征程</div>
      <div class="btns">
        <div class="consult" @click="consultFn">立即咨询专家</div>
        <div class="plan" @click="goSolutionFn">了解解决方案</div>

      </div>
    </div>
  </div>
</template>

<script>

import { queryByModuleCodeApi } from '../api/common'
import { queryPlanByPageApi } from '../api/product'
export default {

  name: 'HomeView',
  data() {
    return {
      swiperOptions: {
        initialSlide: 1,
        //自动播放设置
        autoplay: {
          delay: 6000,
        },

        //图片下面有小圆点，代表到哪一张图片
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        //下面这三个是图片的轮播展示效果
        effect: 'coverflow',
        slidesPerView: 3,
        // centeredSlides: true,
        loop: true,
      },
      datas: [],
      desc: '',
      service: '',
      partner: '',
      cases: '',
      caseItem: '',
      evaluate: '',
      
    }
  },
  created() {
    this.getHomePageDesc()
    this.getHomePageData()
    this.getHomePageService()
    this.getHomePagePartner()
    this.getProductServiceCase()
    this.queryPlanByPageFn()
    this.getHomePageEvaluate()
  },
  methods: {
    async queryByModuleCodeFn(tag) {
      const res = await queryByModuleCodeApi({ moduleCode: tag })
      return res
    },
    async getHomePageDesc() {
      const res = await this.queryByModuleCodeFn('gzkm_home_page_desc')
      this.desc = res.data
    },
    // 数据展示
    async getHomePageData() {
      const res = await this.queryByModuleCodeFn('gzkm_home_page_data')
      this.datas = res.data.moduleChildListDto
    },
    // 产品核心与服务
    async getHomePageService() {
      const res = await this.queryByModuleCodeFn('gzkm_home_page_service')
      this.service = res.data
    },
    // 值得信赖的合作伙伴
    async getHomePagePartner() {
      const res = await this.queryByModuleCodeFn('gzkm_home_page_partner')
      this.partner = res.data
    },
    // 成功案例展示
    async getProductServiceCase() {
      const res = await this.queryByModuleCodeFn('gzkm_home_page_service_case')
      this.cases = res.data
    },
    async queryPlanByPageFn() {
      const res = await queryPlanByPageApi({ current: 1, size: 3, moduleCode: 'gzkm_case_showcase_sort_all' })
      this.caseItem = res.data.list
    }, 
    // 客户对我们的评价
    async getHomePageEvaluate() {
      const res = await this.queryByModuleCodeFn('gzkm_home_page_evaluate')
      this.evaluate = res.data
    },
    // 咨询解决方案
    consultFn() {
      this.$store.commit('user/SET_DRAWER', true)
    },
    // 查看成功案例
    lookSuccess() {
      this.$router.push('/demo')
    },
    // 查看全部产品
    lookAllProFn() {
      this.$router.push('/product')
    },
    // 了解解决方案
    goSolutionFn() {
      this.$router.push('/solution')
    },
    lookCase(id) {
      this.$router.push(`/demoDetail/${id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  .banner-container {
    width: 100%;
    height: 310px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .innovate-container {
    padding: 0 50px;
    box-sizing: border-box;
    width: 100%;
    min-width: 1600px;
    height: 430px;
    margin-top: 23px;

    .innovate-wrap {
      height: 100%;
      width: 100%;
      overflow: hidden;
      border-radius: 20px;
      // background-image: url('../assets/images/图1.jpg');
      background-repeat: no-repeat;
      background-size: cover;

      .big-title {
        width: 746px;
        height: 158px;
        padding: 0 100px;
        box-sizing: border-box;
        line-height: 66px;
        color: rgba(51, 51, 51, 1);
        font-size: 50px;
        text-align: center;
        // font-family: PingFangSC-bold;
        font-weight: 500;
        margin-top: 68px;
        margin-left: 100px;
      }

      .small-desc {
        width: 727px;
        height: 79px;
        line-height: 25px;
        color: rgba(79, 79, 79, 1);
        font-size: 18px;
        text-align: center;
        font-family: PingFangSC-light;
        margin-left: 100px;
      }

      .btns {
        display: flex;
        margin-left: 300px;

        .zixun {
          width: 172px;
          height: 72px;
          line-height: 72px;
          border-radius: 8px;
          background-color: rgba(255, 255, 255, 1);
          color: rgb(136, 134, 134);
          font-size: 16px;
          text-align: center;
          font-family: PingFangSC-regular;
          position: relative;
          transition: color 0.4s linear;
          cursor: pointer;
          margin-right: 20px;
          overflow: hidden;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(39, 94, 255, 1);
            transition: transform 0.5s;
            transform-origin: 0 0;
            transition-timing-function: cubic-bezier(0.5, 1.6, 0.4, 0.7);
            transform: scaleX(0);
            z-index: -1;
          }

          &:hover {
            color: #fff;
            z-index: 2;

            &::before {
              transform: scaleX(1);
            }
          }
        }

        .look {
          width: 172px;
          height: 72px;
          line-height: 72px;
          border-radius: 8px;
          background-color: rgba(255, 255, 255, 1);
          color: rgb(136, 134, 134);
          font-size: 16px;
          text-align: center;
          font-family: PingFangSC-regular;
          cursor: pointer;
          position: relative;
          overflow: hidden;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(39, 94, 255, 1);
            transition: transform 0.5s;
            transform-origin: 0 0;
            transition-timing-function: cubic-bezier(0.5, 1.6, 0.4, 0.7);
            transform: scaleY(0);
            z-index: -1;
          }

          &:hover {
            color: #fff;
            z-index: 2;

            &::before {
              transform: scaleY(1);
            }
          }
        }
      }
    }
  }

  .data-container {
    width: 100%;
    min-width: 1600px;
    box-sizing: border-box;
    padding: 100px 0 46px 0;

    .data-wrap {
      width: 1600px;
      display: flex;
      justify-content: space-around;
      margin: 0 auto;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .num {
          color: rgba(39, 94, 255, 1);
          font-size: 48px;
          font-weight: bolder;
        }
      }
    }
  }

  .about-container {
    width: 100%;
    min-width: 1600px;
    // height: 503px;
    padding: 50px 0;
    box-sizing: border-box;
    background-color: rgba(249, 250, 251, 1);

    .about-wrap {
      width: 1600px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;

      .left {
        flex: 1;
        margin-right: 150px;

        .title {
          color: rgba(33, 35, 40, 1);
          font-size: 36px;
          text-align: left;
        }

        .desc {
          color: rgba(76, 80, 89, 1);
          font-size: 18px;
          line-height: 25px;
          margin-top: 20px;
        }

        .power {
          margin-top: 30px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .item {
            display: flex;
            margin-top: 30px;

            .icons {
              width: 40px;
              height: 40px;
              margin-right: 10px;
              border-radius: 6px;
              background-color: rgba(218, 228, 255, 1);
              line-height: 40px;
              text-align: center;
            }

            .content {
              display: flex;
              flex-direction: column;
              height: 40px;
              justify-content: space-between;

              .name {
                color: rgba(33, 35, 40, 1);
              }

              .text {
                color: rgba(76, 80, 89, 1);
                font-size: 14px;
                text-align: justify;
              }
            }
          }
        }
      }

      .right {
        width: 607px;
        height: 406px;
        border-radius: 20px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .product-container {
    width: 100%;
    min-width: 1600px;
    padding: 47px 0 60px 0;

    .title {
      line-height: 50px;
      color: rgba(33, 35, 40, 1);
      font-size: 36px;
      text-align: center;
      font-family: Roboto-medium;
    }

    .sub-title {
      line-height: 25px;
      color: rgba(76, 80, 89, 1);
      font-size: 18px;
      text-align: center;
      font-family: Roboto-regular;
      margin-top: 20px;
    }

    .card-wrap {
      width: 1600px;
      margin: 0 auto;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      height: 415px;

      .card-item {
        width: 500px;
        height: 408px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 9px 5px 0px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        cursor: pointer;

        .img {
          width: 100%;
          height: 224px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .content {
          padding: 20px;
          box-sizing: border-box;

          .content-title {
            color: rgba(33, 35, 40, 1);
            font-size: 20px;
            text-align: left;
            font-weight: bolder;
          }

          .content-desc {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            /* 限制最多显示3行 */
            overflow: hidden;
            text-overflow: ellipsis;
            /* 可选，部分浏览器不生效 */
            word-break: break-word;
            color: rgba(76, 80, 89, 1);
            text-align: left;
            line-height: 22px;
            margin-top: 10px;
          }

          .content-tip {
            font-size: 14px;
            text-align: left;
            color: rgba(39, 94, 255, 1);
            cursor: pointer;
            margin-top: 20px;
          }
        }

      }
    }

    .look-all {
      display: flex;
      justify-content: center;
      margin-top: 50px;

      span {
        display: block;
        width: 172px;
        height: 62px;
        line-height: 62px;
        border-radius: 8px;
        background-color: rgba(255, 255, 255, 1);
        color: rgba(39, 94, 255, 1);
        font-size: 16px;
        text-align: center;
        font-family: PingFangSC-regular;
        border: 1px solid rgba(39, 94, 255, 1);
        cursor: pointer;
        text-align: center;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(39, 94, 255, 1);
          transition: transform 0.5s;
          transform-origin: 0 0;
          transition-timing-function: cubic-bezier(0.5, 1.6, 0.4, 0.7);
          transform: scaleX(0);
          transform-origin: 100% 100%;
          z-index: -1;
        }

        &:hover {
          color: #fff;
          z-index: 2;

          &::before {
            transform: scaleX(1);
          }
        }
      }
    }
  }

  .coop-container {
    width: 100%;
    min-width: 1600px;
    min-height: 349px;
    background-color: rgb(249, 250, 252);
    padding-top: 28px;
    padding-bottom: 28px;
    overflow: hidden;

    .title {
      line-height: 50px;
      color: rgba(45, 128, 255, 1);
      ;
      font-size: 36px;
      text-align: center;
      font-family: Roboto-medium;
    }

    .sub-title {
      line-height: 25px;
      color: rgba(76, 80, 89, 1);
      font-size: 18px;
      text-align: center;
      font-family: Roboto-regular;
      margin-bottom: 30px;
      margin-top: 10px;
    }

    .logo-row-BtmM {
      height: 140px;
      position: relative;
      overflow: hidden;
      width: 100%;

      // &:not(:last-child) {
      //   margin-bottom: 30px;
      // }


      .logo-row-track-SYyh {
        display: flex;
        align-items: center;
        // height: 100%;
        animation: move-vvFa 5s linear infinite;
        position: absolute;
        will-change: transform;
        z-index: 1;

        // animation-play-state: paused;
        .partner-logo-container-rGcQ {
          display: flex;
          align-items: center;
          // height: 100%;
          // background: #fff;
          // border-radius: 8px;
          // box-shadow: 0 1.898px 5.693px 0 rgba(0, 0, 0, .05);
          justify-content: center;
          margin-right: 30px;
          // min-width: 1600px;

          // .logo-wrap {
          //   width: 100px;
          //   height: 58px;
          //   border-left: 1px solid #000;
          //   border-right: 1px solid #000;
          //   line-height: 58px;
          //   text-align: center;
          //   position: relative;
          //   &::after, &::before {
          //     position: absolute;
          //     content: '';
          //     width: 100px;
          //     height: 58px;
          //     border-left: 1px solid #000;
          //     border-right: 1px solid #000;
          //     line-height: 58px;
          //     text-align: center;
          //     left: 0;
          //     top: 0;
          //   }
          //   &::after {
          //     transform: rotate(60deg);
          //   }
          //   &::before {
          //     transform: rotate(-60deg);
          //   }
          // }
          .logo-wrap {
            width: 140px;
            height: 140px;
            background-image: url('../assets/images/logobg.png');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: 0 0;
            display: flex;
            align-items: center;
            justify-content: center;


            .partner-logo-RBoq {
              object-fit: contain;
              object-position: center;
              width: 90%;
            }
          }
        }
      }
    }


    @keyframes move-vvFa {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(-50%);
      }
    }
  }

  .success-container {
    width: 100%;
    min-width: 1600px;
    padding: 100px 0 75px 0;
    box-sizing: border-box;

    .success-wrap {
      width: 1600px;
      margin: 0 auto;

      .title {
        font-size: 36px;
        // font-weight: bolder;
      }

      .sub-title {
        color: rgba(76, 80, 89, 1);
        font-size: 16px;
        margin-top: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .all-sucess {
          color: #275EFF;
          cursor: pointer;
        }
      }

      .card-wrap {
        margin-top: 60px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .card-item {
          width: 480px;
          height: 314px;
          box-shadow: 0px 9px 8px 0px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          overflow: hidden;
          position: relative;
          cursor: pointer;

          .item-img-wrap {
            position: relative;

            img {
              width: 100%;
              height: 224px;

            }

            .desc {
              position: absolute;
              left: 20px;
              bottom: 30px;

              .tag {
                width: 68px;
                height: 26px;
                line-height: 26px;
                border-radius: 25px;
                background-color: rgba(39, 94, 255, 1);
                color: rgba(255, 255, 255, 1);
                font-size: 12px;
                text-align: center;
                font-family: PingFangSC-regular;
              }

              .title {
                color: rgba(255, 255, 255, 1);
                font-size: 18px;
                text-align: left;
                font-family: Roboto-regular;
                margin-top: 5px;
              }
            }
          }

          .txt {
            color: rgba(76, 80, 89, 1);
            font-size: 14px;
            line-height: 22px;
            // margin-top: 4px;
            padding: 20px;
            box-sizing: border-box;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            /* 限制最多显示3行 */
            overflow: hidden;
            text-overflow: ellipsis;
            /* 可选，部分浏览器不生效 */
            word-break: break-word;
          }

          .detail-wrap {
            position: absolute;
            left: 0;
            bottom: -90px;
            width: 100%;
            height: 90px;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 20px;
            box-sizing: border-box;
            transition: all 0.3s ease;

            span {
              cursor: pointer;
              width: 100%;
              text-align: center;
              height: 40px;
              line-height: 40px;
              border-radius: 5px;
              background-color: #275EFF;
              color: #fff;
              font-weight: bolder;
            }
          }

          &:hover {
            .detail-wrap {
              bottom: 0;
              transition: all 0.3s ease;
            }

          }
        }
        //  &::after {
        //   content: '';
        //   width: 480px;
        //   height: 314px;
        // }

      }
    }
  }

  .evaluate-container {
    width: 100%;
    min-width: 1600px;
    height: 564px;
    // background-color: #192335;
    background-image: url('../assets/images/图5.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 80px;
    box-sizing: border-box;

    .title {
      color: #2D80FF;
      font-size: 36px;
      text-align: center;
      font-family: Roboto-medium;
    }

    .text {
      margin-top: 20px;
      color: #6C6C6C;
      font-size: 18px;
      text-align: center;
      font-family: Roboto-regular;
    }

    .card-wrap {
      width: 1600px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 50px;

      .card-item {
        width: 480px;
        height: 256px;
        border-radius: 12px;
        background-color: #fff;
        padding: 30px;
        box-sizing: border-box;

        .icons {}

        .txt {
          font-size: 15px;
          line-height: 24px;
          color: #4f4f4f;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          /* 限制最多显示3行 */
          overflow: hidden;
          text-overflow: ellipsis;
          /* 可选，部分浏览器不生效 */
          word-break: break-word;
        }

        .info {
          display: flex;
          margin-top: 10px;

          .avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 10px;

            img {
              width: 100%;
              height: 100%;
            }

          }

          .name-desc {
            display: flex;
            flex-direction: column;

            .name {
              color: #4f4f4f;
            }

            .desc {
              color: #6C6C6C;
              font-size: 13px;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  .consult-container {
    width: 100%;
    min-width: 1600px;
    height: 354px;
    background: linear-gradient(90.98deg, rgba(39, 94, 255, 1) 1.33%, rgba(65, 198, 194, 1) 98.78%);
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      color: rgba(255, 255, 255, 1);
      font-size: 36px;
      text-align: center;
      font-family: Roboto-medium;
    }

    .text {
      margin-top: 20px;
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      text-align: center;
      font-family: Roboto-regular;
    }

    .btns {
      display: flex;
      justify-content: center;
      margin-top: 60px;

      .consult {
        width: 172px;
        height: 62px;
        line-height: 62px;
        border-radius: 8px;
        background-color: rgba(255, 255, 255, 1);
        color: rgba(39, 94, 255, 1);
        font-size: 16px;
        text-align: center;
        font-family: PingFangSC-regular;
        margin-right: 20px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(90.98deg, rgba(39, 94, 255, 1) 1.33%, rgba(65, 198, 194, 1) 98.78%);
            transition: transform 0.5s;
            transform-origin: 0 0;
            transition-timing-function: cubic-bezier(0.5, 1.6, 0.4, 0.7);
            transform: scaleY(0);
            z-index: -1;
            transform-origin: 100% 100%;
          }

          &:hover {
            color: #fff;
            z-index: 2;
            &::before {
              transform: scaleY(1);
            }
          }
      }

      .plan {
        width: 172px;
        height: 62px;
        line-height: 62px;
        border-radius: 8px;
        // background-color: rgba(255, 255, 255, 0);
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        text-align: center;
        font-family: PingFangSC-regular;
        border: 1px solid rgba(255, 255, 255, 1);
        cursor: pointer;
        overflow: hidden;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background: #fff;
            transition: transform 0.5s;
            transform-origin: 0 0;
            transition-timing-function: cubic-bezier(0.5, 1.6, 0.4, 0.7);
            transform: scaleY(0);
            z-index: -1;
          }

          &:hover {
            color: rgba(39, 94, 255, 1);
            z-index: 2;
            &::before {
              transform: scaleY(1);
            }
          }
      }
    }
  }
}
</style>
